import { DriverInformationList } from '@/models/DriverInformationModels';
import { AppNotification } from '@/models/NotificationModels';
import { defineStore } from 'pinia';

interface AppState {
	theme: string | null;
	notifications: AppNotification[];
	driverCache: Record<string, DriverInformationList>;
	forceMvr: boolean;
}

export const useAppStore = defineStore({
	id: 'appStore',
		state: (): AppState => {
		return {
			theme: null,
			notifications: [] as AppNotification[],
			driverCache: {} as Record<string, DriverInformationList>,
			forceMvr: false, 
		};
	},
	// this tells the store to persist to local storage
	persist: true,
	getters: {
		// getters are reactive
		getTheme: (state): string | null => state.theme,
		getForceMvr: (state): boolean => state.forceMvr,
		//getNotifications: (state): AppNotification[] => state.notifications,
	},
	actions: {
		setTheme(theme: string): void {
			this.theme = theme;
		},

		setForceMvr(force: boolean): void {
			this.forceMvr = force;
		},

		addNotification(notification: AppNotification): void {
			this.notifications.unshift(notification);
		},
		setDriverCache(key: string, value: DriverInformationList): void { 
			this.driverCache[key] = value; 
		},
		getDriverCache(key: string): DriverInformationList | undefined {
			return this.driverCache[key]; 
		},
		clearDriverCache(key: string): void { 
			delete this.driverCache[key]; 
		},
	}
});